import { render, staticRenderFns } from "./VehicleUsageDistance.vue?vue&type=template&id=22d36806"
import script from "./VehicleUsageDistance.vue?vue&type=script&lang=js"
export * from "./VehicleUsageDistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports